import {Module} from '@fantasmagames/slot/src/common/Module';
import {MenuButtonEvents} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonEvents';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';
import {MainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuView';
import {MainMenuViewEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuViewEvents';
import {MainMenuBasicState} from '@fantasmagames/slot/src/modules/mainmenu/states/MainMenuBasicState';
import {MainMenuOpenState} from '@fantasmagames/slot/src/modules/mainmenu/states/MainMenuOpenState';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {AutoplayHandlerEvents} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerEvents';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {RelaxEvents} from '@fantasmagames/slot/src/integration/RelaxEvents';

export enum MENU {
	PAYTABLE,
	SETTINGS,
	INFO,
}

export class MainMenuModule extends Module<MainMenuView> {
	public static readonly BASIC: string = 'BASIC';
	public static readonly OPEN: string = 'OPEN';

	protected _isInAutoplay: boolean = false;

	public _lastMenu: number = MENU.PAYTABLE;

	protected setupStates(): void {
		this.addState(new MainMenuBasicState(this, MainMenuModule.BASIC));
		this.addState(new MainMenuOpenState(this, MainMenuModule.OPEN));
	}

	protected enterFirstState(): void {
		this.changeStateTo(MainMenuModule.BASIC);
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.MAIN_MENU_VIEW_MOBILE);
		} else {
			this.setView(Views.MAIN_MENU_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(MainMenuEvents.MAIN_MENU_CLOSE_CLICKED, this.hideMenu);
		this.on(MenuButtonEvents.MENU_BUTTON_CLICKED, this.showMenu);

		this.on(AutoplayMenuEvents.ACCEPTED, this.onStartAutoplay);
		this.on(AutoplayHandlerEvents.AUTOPLAY_STOPPED, this.onAutoplayStopped);

		this.on(SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceBarClicked);

		this.onView(MainMenuViewEvents.MAIN_MENU_CLOSE_CLICKED, this.hideMenu);

		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_INFO_OPEN, MainMenuEvents.MAIN_MENU_INFO_OPEN);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN, MainMenuEvents.MAIN_MENU_LOBBY_OPEN);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_SETTINGS_OPEN, MainMenuEvents.MAIN_MENU_SETTINGS_OPEN);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_PAYTABLE_OPEN, MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN);

		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_INFO_CLOSE, MainMenuEvents.MAIN_MENU_INFO_CLOSE);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_LOBBY_CLOSE, MainMenuEvents.MAIN_MENU_LOBBY_CLOSE);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_SETTINGS_CLOSE, MainMenuEvents.MAIN_MENU_SETTINGS_CLOSE);
		this.onViewEmitEvent(MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLOSE, MainMenuEvents.MAIN_MENU_PAYTABLE_CLOSE);

		this.on(MainMenuEvents.MAIN_MENU_INFO_OPEN, this.setLastMenu.bind(this, MENU.INFO));
		this.on(MainMenuEvents.MAIN_MENU_LOBBY_OPEN, this.setLastMenu.bind(this, MENU.PAYTABLE));
		this.on(MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.setLastMenu.bind(this, MENU.SETTINGS));
		this.on(MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.setLastMenu.bind(this, MENU.PAYTABLE));

		this.onCurrentStateHandle(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED);
		this.onCurrentStateHandle(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED);
		this.onCurrentStateHandle(RelaxEvents.SHOW_REALITY_CHECK);

		this.onCurrentStateHandle(LogicEvents.ERROR_RESPONSE);
	}

	protected onStartAutoplay(): void {
		this._isInAutoplay = true;
	}

	protected onAutoplayStopped(): void {
		this._isInAutoplay = false;
	}

	protected onSpaceBarClicked(): void {
		if (!this._isInAutoplay) {
			this.currentState.handle(SpinButtonEvents.SPACE_BUTTON_CLICKED);
		}
	}

	protected setLastMenu(menu: MENU): void {
		this._lastMenu = menu;
	}

	protected showMenu(): void {
		this.gotoState(MainMenuModule.OPEN);
	}

	protected hideMenu(): void {
		this.gotoState(MainMenuModule.BASIC);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/MainMenuModule.ts